import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Old Fixtures & Fittings',
    image: '/images/property-management/property-fixtures-fittings.png',
  },
  {
    title: 'Metal Railings & Grilles',
    image: '/images/property-management/property-railings-grilles.png',
  },
  {
    title: 'Pipework & Conduit',
    image: '/images/property-management/property-pipework-conduit.png',
  },
  {
    title: 'General Building Scrap',
    image: '/images/property-management/property-building-scrap.png',
  },
  {
    title: 'Metal Offcuts',
    image: '/images/property-management/property-metal-offcuts.png',
  },
  {
    title: 'Void Clearance Metal',
    image: '/images/property-management/property-void-metal.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, the property postcode and what metal needs clearing from the site.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing around tenants, voids or contractor works.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Fixtures, railings and building metal leave through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your team keeps turnovers moving while leftovers are cleared properly.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Support tidy void clearances with accountable metal collections.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid tying up staff hauling scrap between properties.',
  },
  {
    title: 'Better for the environment',
    body: 'Building metals are recovered for reuse instead of mixed waste streams.',
  },
  {
    title: 'Built for property teams',
    body: 'Share access notes and photos so collectors arrive ready for site scrap.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear voids faster' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Metal recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function PropertyManagementPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="pm-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="pm-hero-heading">
              Scrap collection for <span>property management companies</span>
            </h1>
            <p className="kf-lead">
              Clear fixtures, railings and building scrap quickly and responsibly — so voids,
              refurbs and contractor works stay tidy and on schedule.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-property-management.png"
              alt="Property management scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for property teams — fixtures, railings, pipework and void metal
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="pm-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="pm-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from voids, refurbs and property maintenance works</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="pm-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="pm-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clearer property</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="pm-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="pm-why-heading">Why property managers choose SnapScrap</h2>
            <p>Clear space, keep turnovers moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your property scrap for free today</h2>
            <p>
              List leftovers from your next void, refurb or maintenance job and get matched with a
              licensed collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
